import { Box, useTheme } from "@mui/material";

interface LogoProps {
    logoUrl?: string;
    logoAlt?: string;
    size?: "small" | "medium" | "large";
    mobileMaxWidth?: string;
}

const logoSizes = {
    small: { xs: "34px", sm: "42px" },
    medium: { xs: "44px", sm: "52px" },
    large: { xs: "64px", sm: "82px" },
};

const Logo = (props: LogoProps) => {
    const { logoUrl, logoAlt, size = "large", mobileMaxWidth } = props;

    const theme = useTheme();

    if (!logoUrl) {
        return null;
    }

    return (
        <Box
            component="img"
            sx={{
                maxHeight: logoSizes[size],
                maxWidth: mobileMaxWidth || "250px",
                [theme.breakpoints.up("sm")]: {
                    maxWidth: "350px",
                },
            }}
            src={logoUrl}
            alt={logoAlt || "Logo"}
        />
    );
};

export default Logo;
